import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginResponseData } from '../models/responses/login-response-data';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { ApproveContractWithTokenDto } from '../models/ApproveContractWithTokenDto';
import { approveContractVm } from '../models/approveContractVm';
import { ApproveMovementWithTokenDto } from '../models/ApproveMovementWithTokenDto'; 
import { ApproveManPowerWithTokenDto } from '../models/ApproveManPowerWithTokenDto';
import { approveContractAxiom } from '../models/approveContractAxiom';

@Injectable({
  providedIn: 'root'
})
export class ContractApprovalService {

  constructor(private httpClient: HttpClient) { }


  BeginApproval(token: string): Observable<ApiResponseObject<ApproveContractWithTokenDto>> {
    return this.httpClient.get<ApiResponseObject<ApproveContractWithTokenDto>>(`${environment.apiUrl}/ContractApprovals/BeginApproval/${token}`);
  }

  approve(approveContractRequest: approveContractAxiom): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/ContractApprovals/Approve`, approveContractRequest);
  }
  rejectContract(approveContractRequest: approveContractAxiom): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/ContractApprovals/Reject`, approveContractRequest);
  }

  
  BeginMovementApproval(token: string): Observable<ApiResponseObject<ApproveMovementWithTokenDto>> {
    
    return this.httpClient.get<ApiResponseObject<ApproveMovementWithTokenDto>>(`${environment.apiUrl}/ContractApprovals/BeginMovementApproval/${token}`);
  }

  
  BeginManpowerApproval(token: string): Observable<ApiResponseObject<ApproveManPowerWithTokenDto>> {
    
    return this.httpClient.get<ApiResponseObject<ApproveManPowerWithTokenDto>>(`${environment.apiUrl}/ContractApprovals/BeginManpowerApproval/${token}`);
  }

  
  ApproveMovementWithToken(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/ContractApprovals/ApproveMovementWithToken`, approveContractRequest);
  }

  

  RejectMovementWithToken(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/ContractApprovals/RejectMovementWithToken`, approveContractRequest);
  }

  ApproveManpowerWithToken(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    let  url =`${environment.apiUrl}/ContractApprovals/ApproveManpowerWithToken`;
    var result = this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/ContractApprovals/ApproveManpowerWithToken`, approveContractRequest);
   ;
    return result;
  }


  RejectManpowerWithToken(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/ContractApprovals/RejectManpowerWithToken`, approveContractRequest);
  }



  

}
